//@ts-expect-error no types for ui-addon-iframeable
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import { useCallback, useMemo } from 'react';
import { MessageTypes } from '../constants/MessageTypes';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getHostUrl, getPathname } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export let InvoiceOperation;
(function (InvoiceOperation) {
  InvoiceOperation["EDIT"] = "EDIT";
  InvoiceOperation["CLONE"] = "CLONE";
  InvoiceOperation["CREATE_BLANK_INVOICE"] = "CREATE_BLANK_INVOICE";
  InvoiceOperation["CONVERT_TO_INVOICE"] = "CONVERT_TO_INVOICE";
})(InvoiceOperation || (InvoiceOperation = {}));
const InvoicesEditorIFrameModal = ({
  show,
  objectId,
  onClose,
  onError,
  objectTypeId,
  operation,
  preloadedPaymentsEligibility,
  preloadedInitialInvoiceData,
  selectedCreateInvoiceFlow,
  isADPT0003Variation,
  triggerCSATSurveyOnLoad
}) => {
  const handleCloseModal = useCallback(updatedInvoice => {
    window.onpopstate = null;
    if (onClose) {
      onClose(updatedInvoice);
    }
  }, [onClose]);
  const handleError = useCallback(error => {
    console.error(error);
    handleCloseModal();
    if (onError) {
      onError(error);
    }
  }, [handleCloseModal, onError]);
  const handleMessage = useCallback(message => {
    const {
      payload: {
        type
      }
    } = message;
    if (type === MessageTypes.MSG_TYPE_HIDE_MODAL) {
      handleCloseModal(message.payload.invoice);
    }
    if (type === MessageTypes.MSG_TYPE_ADD_ALERT) {
      FloatingAlertStore.addAlert(message.payload.alertProps);
    }
  }, [handleCloseModal]);
  const handleOnReady = useCallback(hostContext => {
    hostContext.sendMessage(MessageTypes.MSG_TYPE_APP_READY);
  }, []);
  const src = useMemo(() => {
    if (!show) return null;
    const route = (() => {
      switch (true) {
        case operation === InvoiceOperation.EDIT:
          return `/edit/${objectId}`;
        case operation === InvoiceOperation.CLONE:
          return `/clone/${objectId}`;
        case operation === InvoiceOperation.CONVERT_TO_INVOICE:
          return `/convert/${objectTypeId}/${objectId}`;
        case operation === InvoiceOperation.CREATE_BLANK_INVOICE:
          return !!objectTypeId && !!objectId ? `/create/${objectTypeId}/${objectId}` : `/create`;
        default:
          return null;
      }
    })();
    return `https://${getHostUrl()}${getPathname()}/embedded${route}`;
  }, [operation, objectId, objectTypeId, show]);
  return show && src ? /*#__PURE__*/_jsx(ModalIFrame, {
    appName: "invoices-editor-ui",
    iframePassthruProps: {
      'data-test-id': `invoice-editor-iframe-${show ? 'open' : 'closed'}`,
      id: 'invoice-editor-iframe',
      title: 'Invoice Editor'
    },
    embeddedPassthruProps: {
      preloadedPaymentsEligibility,
      preloadedInitialInvoiceData,
      selectedCreateInvoiceFlow,
      isADPT0003Variation,
      triggerCSATSurveyOnLoad
    },
    initTimeout: 60000,
    use: "fullscreen",
    width: "100%",
    height: "100%",
    src: src,
    showLoadingIndicator: true,
    onInitError: handleError,
    onReady: handleOnReady,
    onReadyError: handleError,
    onMessage: handleMessage,
    onClose: handleCloseModal
  }) : null;
};
export default InvoicesEditorIFrameModal;